import React, { useState } from 'react';
import { FadeIn } from './FadeIn';

export const Contact = () => {
  const [status, setStatus] = useState('idle'); // idle | sending | sent | error

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;

    setStatus('sending');
    try {
      const res = await fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(new FormData(form)).toString(),
      });
      if (res.ok) {
        setStatus('sent');
        form.reset();
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <section id="contact" className="relative py-32 md:py-48 bg-c-dark text-c-cream noise-overlay">
      <div aria-hidden="true" className="absolute top-0 left-1/2 -translate-x-1/2 w-[60%] h-[200px] bg-gradient-to-b from-c-mauve/8 to-transparent pointer-events-none"></div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-8">

        <div className="lg:col-span-5">
          <FadeIn>
            <h2 className="text-xs font-medium tracking-super-wide uppercase text-c-powder mb-6">Inquiries</h2>
            <h3 className="text-4xl md:text-5xl font-light leading-[1.2] mb-8">
              A graceful <br/>
              <span className="font-serif-italic text-c-mauve/80">invitation.</span>
            </h3>
            <p className="text-c-powder/60 font-light text-lg max-w-sm mb-12">
              We respond to select inquiries within 24 hours to discuss strategic alignment and partnership potential.
            </p>
            <div className="space-y-4 text-sm font-light text-c-powder/80">
              <a href="mailto:hello@chrsma.co" className="block hover:text-c-cream transition-colors">hello@chrsma.co</a>
              <p>New York, NY</p>
            </div>
          </FadeIn>
        </div>

        <div className="lg:col-span-6 lg:col-start-7">
          <FadeIn delay={0.2}>
            {status === 'sent' ? (
              <div className="flex flex-col items-start justify-center h-full py-20">
                <h4 className="text-2xl font-light text-white mb-4">Thank you.</h4>
                <p className="text-c-powder/70 font-light leading-relaxed">
                  We've received your inquiry and will respond within 24 hours.
                </p>
              </div>
            ) : (
              <form
                name="contact"
                method="POST"
                data-netlify="true"
                netlify-honeypot="bot-field"
                onSubmit={handleSubmit}
                className="space-y-10"
              >
                <input type="hidden" name="form-name" value="contact" />
                <p className="hidden"><label>Don't fill this out: <input name="bot-field" /></label></p>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
                  <div>
                    <label className="sr-only">Name</label>
                    <input type="text" name="name" placeholder="Your name" required className="form-input" />
                  </div>
                  <div>
                    <label className="sr-only">Company</label>
                    <input type="text" name="company" placeholder="Your company" className="form-input" />
                  </div>
                </div>
                <div>
                  <label className="sr-only">Email</label>
                  <input type="email" name="email" placeholder="Best email to reach you" required className="form-input" />
                </div>
                <div>
                  <label className="sr-only">Message</label>
                  <textarea
                    name="message"
                    placeholder="What positioning challenge are you facing?"
                    required
                    rows="4"
                    className="form-input resize-none"
                  ></textarea>
                </div>
                <div className="pt-8 flex items-center gap-6">
                  <button
                    type="submit"
                    disabled={status === 'sending'}
                    className={`text-xs font-medium tracking-widest uppercase px-8 py-3.5 rounded-xl cta-wire ${
                      status === 'sending' ? 'opacity-50 pointer-events-none' : ''
                    }`}
                  >
                    {status === 'sending' ? 'Sending...' : 'Submit Inquiry'}
                  </button>
                  {status === 'error' && (
                    <p className="text-sm text-c-coral/80 font-light">Something went wrong. Try again or email us directly.</p>
                  )}
                </div>
              </form>
            )}
          </FadeIn>
        </div>
      </div>
    </section>
  );
};
